import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'
import { Relayout, RelayoutItem, RelayoutWrapper } from 'relayout'

import { homeLoadPage, homeLoadPastEventGroups } from 'actions/home'
import EventList from 'components/event-list'
import EventReviewList from 'components/event-review-list'
import Loader from 'components/loader'
import LoadMore from 'components/load-more'
import EmptyEvents from 'components/empty-events'
import { canLoadMore, isFetching } from 'selectors/paginate'
import { getPartnerPermissions } from 'selectors/entities'
import { getCurrentPartner } from 'selectors/settings'
import { getPartnerUrl } from 'utils/urls'
import {
  getEventGroupsWithVenues,
  getPastEventGroupsWithVenues,
  getSubmittedSetupforms,
  isFetchingEventGroups,
  isFetchingSetupforms,
} from 'selectors/home'

import styles from './home-page.css'

export class HomePage extends Component {

  constructor(props) {
    super(props)

    this.loadMorePastEventGroups = this.loadMorePastEventGroups.bind(this)
  }

  componentDidMount() {
    const { params } = this.props
    this.props.homeLoadPage(params.partnerId)
  }

  loadMorePastEventGroups() {
    this.props.homeLoadPastEventGroups(this.props.params.partnerId, true)
  }

  hasLoaded() {
    return !this.props.isFetchingEventGroups && !this.props.isFetchingSetupforms
  }

  hasAnyEvents() {
    const { eventGroups, pastEventGroups, submittedSetupforms } = this.props
    return eventGroups.length > 0 || pastEventGroups.length > 0 || submittedSetupforms.length > 0
  }

  renderLoader() {
    return (
      <div styleName="centered">
        <Loader center />
      </div>
    )
  }

  renderEmptyEvents() {
    const { partnerId } = this.props.params
    const { canAddEvents } = this.props
    return (
      <div styleName="centered">
        <EmptyEvents
          action="Create an event"
          description={
            <span>Welcome to your Portal homepage.<br />
            Here you can check events in review, view sales and add new dates to past events.</span>
          }
          link={canAddEvents ? getPartnerUrl(partnerId, '/sf/new') : null}
        />
      </div>
    )
  }

  renderEvents() {
    const {
      canLoadMorePastEventGroups,
      eventGroups,
      isDataFetching,
      params,
      pastEventGroups,
      submittedSetupforms,
    } = this.props

    return (
      <RelayoutWrapper>
        <Relayout align="center">
          <RelayoutItem xl="10">
            {submittedSetupforms.length > 0 &&
              <EventReviewList
                events={submittedSetupforms}
                partnerId={params.partnerId}
                subtitle="Submitted events/products in-review by the YPlan team"
                title="In Review"
              />
            }
            {eventGroups.length > 0 &&
              <EventList
                dateField="nextStartTime"
                events={eventGroups}
                partnerId={params.partnerId}
                subtitle="Events now live and available on YPlan"
                title="Live Events"
              />
            }
            {pastEventGroups.length > 0 &&
              <EventList
                dateField="lastStartTime"
                events={pastEventGroups}
                partnerId={params.partnerId}
                subtitle="Add new dates to get them live on YPlan again"
                title="Past Events"
              />
            }
            {canLoadMorePastEventGroups &&
              <LoadMore loading={isDataFetching} onClick={this.loadMorePastEventGroups} />
            }
          </RelayoutItem>
        </Relayout>
      </RelayoutWrapper>
    )
  }

  render() {
    const hasLoaded = this.hasLoaded()
    const hasAnyEvents = hasLoaded && this.hasAnyEvents()

    return (
      <div styleName="page">
        {!hasLoaded && this.renderLoader()}
        {hasLoaded && !hasAnyEvents && this.renderEmptyEvents()}
        {hasLoaded && hasAnyEvents && this.renderEvents()}
      </div>
    )
  }

}

HomePage.propTypes = {
  canAddEvents: PropTypes.bool,
  canLoadMorePastEventGroups: PropTypes.bool,
  eventGroups: PropTypes.array,
  homeLoadPage: PropTypes.func,
  homeLoadPastEventGroups: PropTypes.func,
  isDataFetching: PropTypes.bool,
  isFetchingEventGroups: PropTypes.bool,
  isFetchingSetupforms: PropTypes.bool,
  params: PropTypes.object,
  pastEventGroups: PropTypes.array,
  submittedSetupforms: PropTypes.array,
}

const mapStateToProps = (state, ownProps) => {
  const partner = getCurrentPartner(state)
  const { partnerId } = ownProps.params

  return {
    canAddEvents: partner && getPartnerPermissions(partnerId)(state).canAddEvents,
    canLoadMorePastEventGroups: canLoadMore('partnerPastEventGroups', partnerId)(state),
    eventGroups: getEventGroupsWithVenues(partnerId)(state),
    isDataFetching: isFetching('partnerPastEventGroups', partnerId)(state),
    isFetchingEventGroups: isFetchingEventGroups(state),
    isFetchingSetupforms: isFetchingSetupforms(state),
    pastEventGroups: getPastEventGroupsWithVenues(partnerId)(state),
    submittedSetupforms: getSubmittedSetupforms(partnerId)(state),
  }
}

const mapDispatchToProps = { homeLoadPage, homeLoadPastEventGroups }

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(HomePage, styles))



/** WEBPACK FOOTER **
 ** ./src/containers/home-page/home-page.js
 **/